import { proceedElectricity, proceedCable, proceedEducation } from '@/api/bills'
import { mapActions } from 'vuex'

export default {
    methods: {
        ...mapActions('Message', {
            setMessageType: 'SET_MESSAGE_TYPE',
            setMessage: 'SET_MESSAGE',
        }),

        setError(err) {
            this.error = true
            setTimeout(() => {
                this.error = false
            }, 500)
            this.payload = {}
            let message
            if (err.response.status === 422) {
                let errors = err.response.data.errors
                errors = Object.values(errors)
                message = errors[0][0]
            } else {
                message = err.response.data.message
            }
            this.setMessageType(false)
            this.setMessage(message)
        },

        payElectricity(data) {
            proceedElectricity(data)
                .then((response) => {
                    this.payload = response.data.data
                    this.initializeTransactionNotification(
                        `You initialized an electricity payment for <b>${data.product_name}</b> with meter number <b>${data.customer_id}</b>`
                    )
                })
                .catch((err) => {
                    console.dir(err)
                    this.setError(err)
                })
        },

        payCable(data) {
            proceedCable(data)
                .then((response) => {
                    this.payload = response.data.data
                    this.initializeTransactionNotification(
                        `You initialized a cable payment for <b>${data.tv_category}</b> bundle <b>${data.bundle}</b>`
                    )
                })
                .catch((err) => {
                    console.dir(err)
                    this.setError(err)
                })
        },

        payEducation(data) {
            proceedEducation(data)
                .then((response) => {
                    this.payload = response.data.data
                    this.initializeTransactionNotification(`You initialized a education payment`)
                })
                .catch((err) => {
                    console.dir(err)
                    this.setError(err)
                })
        },

        initializeTransactionNotification(text) {
            this.setNotification({
                type: 1,
                title: 'Your transaction has been initialized',
                body: text,
                created_at: new Date(),
                seen: false,
            })
        },
    },
}
